import { render, staticRenderFns } from "./DistCont2.vue?vue&type=template&id=4e64e7d1&scoped=true&"
import script from "./DistCont2.vue?vue&type=script&lang=js&"
export * from "./DistCont2.vue?vue&type=script&lang=js&"
import style0 from "./DistCont2.vue?vue&type=style&index=0&id=4e64e7d1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e64e7d1",
  null
  
)

export default component.exports